<template>
	<fragment>
		<common-header
			subname="설문 관리"
			name="설문문항 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<ctrl-filter listName="설문문항 목록" @changeFilters="changeFilters"></ctrl-filter>

			<div class="container-fiuld">
				<!-- <div class="search-box">
					<input id="search" class="form-control round full-width m-b-0" type="text">
					<label for="search">검색</label>
				</div> -->
				<div class="btn-group-box clearfix">
					<!-- <div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" @click="removeAllItem">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
									<path class="recycle"
										d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
										transform="translate(-502.5 -1247)"></path>
								</svg> 삭제
							</a>
						</div>
					</div> -->
					<!-- //end .btn-group -->

					<div class="btn-group pull-right clearfix">
						<select v-model="pageSize" @change="setPageSizeOrder()" class="form-control round pull-left m-r-5">
							<option value="10">10개씩 보기</option>
							<option value="20">30개씩 보기</option>
							<option value="30">50개씩 보기</option>
						</select>
						<select v-model="orderBy" @change="setPageSizeOrder()" class="form-control round pull-left m-r-5">
							<option value="surveyItemId">정렬</option>
							<option value="type">유형 가나다순</option>
							<option value="itemName">설문 가다나순</option>
							<option value="regMberName">작성자 가나다순</option>
							<option value="regDate DESC">작성일 최신순</option>
							<option value="regDate">작성일 과거순</option>
						</select>
						<!-- <div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div> -->
					</div>
					<!-- //end .btn-group -->
				</div>
				<!-- //end .btn-group-box -->

				<table class="table2 table-hover m-t-10 text-center">
					<thead>
						<tr class="bg-lightgray">
							<!-- <th>
								<input @click="allChecked" v-model="checked_all"
										id="table-allcheck" class="checkbox" type="checkbox">
								<label for="table-allcheck">체크버튼</label>
							</th> -->
							<th>카테고리</th>
							<th>유형</th>
							<th>설문</th>
							<th>작성자</th>
							<th>작성일</th>
							<th>관리</th>
						</tr>
					</thead>
					<tbody>
						<tr class="margin">
							<td colspan="7"></td>
						</tr>
						<template v-for="survey_item in survey_item_list">
							<tr :key="survey_item.surveyItemId">
								<!-- <td>
									<input
										type="checkbox"
										:id="'surveyItem-'+survey_item.surveyItemId"
										:value="survey_item.surveyItemId"
										v-model="checked_item"
										class="checkbox"
									>
									<label :for="'surveyItem-'+survey_item.surveyItemId">체크버튼</label>
									<input
										v-model="checked_item"
										:value="survey_item.surveyItemId"
										:id="'surveyItem-'+survey_item.surveyItemId"
										class="checkbox"
										type="checkbox"
									>
								</td> -->
								<td>
									{{parseSurveyCategory(survey_item.surveyCategoryId)}}
								</td>
								<td>{{survey_item.type}}</td>
								<td>
									{{survey_item.itemName}}
								</td>
								<td>
									{{survey_item.regMerName}}
								</td>
								<td>{{parseDate(survey_item.regDate)}}</td>
								<td>
									<a class="more m-r-10" @click="getSurveyDetail(survey_item)">상세</a>
									<a class="modify m-r-10" @click="modifySurveyItem(survey_item)">수정</a>
									<a class="del" @click="deleteSurvey(survey_item.surveyItemId)">삭제</a>
								</td>
							</tr>
							<tr class="margin" :key="'margin' + survey_item.surveyItemId">
								<td colspan="7"></td>
							</tr>
						</template>
					</tbody>
				</table>

				<ctrl-pagination :currentPage="offset / pageSize + 1"
					:pageSize="parseInt(pageSize)" :totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"></ctrl-pagination>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-survey-register
			:config="modals.ModalSurveyRegister"
			:key="'modal-survey-register-'+hash(modals.ModalSurveyRegister)"
			@close="modals.ModalSurveyRegister.show=false;"
			@refresh="refreshData({msg: '등록 되었습니다.'})()"
		></modal-survey-register>
		<modal-survey-detail
			:config="modals.ModalSurveyDetail"
			:key="'modal-survey-detail-'+hash(modals.ModalSurveyDetail)"
			@close="modals.ModalSurveyDetail.show=false;"
			@modifyItem="survey_item => modifySurveyItem(survey_item)"
			@removeItem="survey_item => deleteSurvey(survey_item.surveyItemId)"
		></modal-survey-detail>
		<modal-survey-modify
			:config="modals.ModalSurveyModify"
			@close="modals.ModalSurveyModify.show=false;"
			:key="'modal-survey-modify-'+hash(modals.ModalSurveyModify)"></modal-survey-modify>
		<modal-survey-register-excel :config="modals.ModalSurveyRegisterExcel" @reload="refreshData" @close="modals.ModalSurveyRegisterExcel.show=false;" :key="'modal-survey-register-excel-'+hash(modals.ModalSurveyRegisterExcel)"></modal-survey-register-excel>
		<modal-confirm :config="modals.ModalConfirm" @yes="removeCancleItem()" @no="removeItem()" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlFilter from '../components/CtrlFilter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'

import ModalSurveyRegister from '../modals/ModalSurveyRegister.vue'
import ModalSurveyDetail from '../modals/ModalSurveyDetail.vue'
import ModalSurveyModify from '../modals/ModalSurveyModify.vue'
import ModalSurveyRegisterExcel from '../modals/ModalSurveyRegisterExcel.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import server from '../statics/server'
import _ from 'lodash'
import moment from 'moment'
export default {
	// 컴포넌트 명칭
	name: "ViewSurveyList",
	mixins: [fnAdjustHeight],

	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		CtrlFilter,
		CtrlPagination,
		ModalSurveyRegister,
		ModalSurveyDetail,
		ModalSurveyModify,
		ModalSurveyRegisterExcel,
		ModalConfirm,
		ModalAlert,
	},
	// 이 컴포넌트에서 사용할 내부데이터
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'설문 관리',link:"/surveys",selected:false},
				{name:'설문문항 관리',link:"/surveyItems",selected:true},
				{name:'설문 분류',link:"/surveys/categories",selected:false},
				{name:'설문 통계',link:"/surveys/statistics",selected:false},
			],
			buttons: [
				{name: '설문문항 등록', fn: () => {
					this.openNewSurveyModal();
				}},
				{name: '설문문항 일괄등록', fn: () => {
					this.openNewSurveyExcelModal();
				}},
			], // 헤더버튼
			modals: {
				ModalSurveyRegister: ModalSurveyRegister.default(),
				ModalSurveyDetail: ModalSurveyDetail.default(),
				ModalSurveyModify: ModalSurveyModify.default(),
				ModalSurveyRegisterExcel: ModalSurveyRegisterExcel.default(),
				ModalAlert: ModalAlert.default(),
				ModalConfirm: ModalConfirm.default(),
			}, // 모달 설정객체 모음
			survey_list : [],
			survey_category_list : [],
			survey_item_list : [],
			survey_item_map_list : [],
			survey_appl : [],
			survey_item_appl : [],
			init_list : [
				{db_name : 'SURVEY', list_name :'survey_list'},
				{db_name : 'SURVEY_CATEGORY', list_name :'survey_category_list'},
				{db_name : 'SURVEY_ITEM', list_name :'survey_item_list'},
				{db_name : 'SURVEY_ITEM_MAPPING', list_name :'survey_item_map_list'},
				{db_name : 'SURVEY_APPL', list_name :'survey_appl'},
				{db_name : 'SURVEY_ITEM_APPL', list_name :'survey_item_appl'},

			],
			remove_survey_item : '',
			checked_item : [],
			checked_all : false,

			// 정렬
			totalCount : 0,
			offset : 0,
			keyword : '',
			pageSize : 10,
			orderBy : "surveyItemId",
			filterList : ''
		}
	},
	mounted(){
		/* _.forEach(this.init_list, (obj, idx) => {
			this.getList(obj.db_name, obj.list_name);
		}) */
		this.getList(this.init_list[1].db_name, this.init_list[1].list_name, {});
		// 리스트 초기화 + 페이지네이션 기능
		this.setPageSizeOrder();
	},

	// 이 컴포넌트에서 구현할 기능
	methods: {
		onPageChanged(page){
			this.offset = (page - 1) * this.pageSize;
			this.setPageSizeOrder();
		},
		changeFilters(filter_list){
			this.filter_list = filter_list;
			this.setPageSizeOrder();
		},
		setPageSizeOrder(){
			let config_option = {
				parentsId : '0',
				offset : this.offset ,
				pageSize : this.pageSize,
				orderBy : this.orderBy,
				filterList : this.filterList
			}
			config_option = _.pickBy(config_option);
			this.getList(this.init_list[2].db_name, this.init_list[2].list_name, config_option);
		},
		// refreshData(){
		// 	this.getList(this.init_list[2].db_name, this.init_list[2].list_name, {parentsId : 0});
		// },
		refreshData({msg}) {
			return () => {
				this.modals.ModalAlert.msg = msg;
				this.modals.ModalAlert.show = true;
				this.setPageSizeOrder(); 
			};
		},
		parseDate(datetime){
			return moment(datetime).format('YYYY-MM-DD')
		},
		parseSurveyCategory(surveyCategoryId){
			const self = this;
			let parentsId = surveyCategoryId;
			let category_name = [];
			for(var i=0; i < 3; i++){
				if(_.find(self.survey_category_list, {surveyCategoryId : parentsId})){
					category_name.push(_.find(self.survey_category_list, {surveyCategoryId : parentsId}).name);
					parentsId = _.find(self.survey_category_list, {surveyCategoryId : parentsId}).parentsId;
				}
				if(parentsId == 0) break;
			}
			return _.reverse(category_name).join(' > ');
		},
		allChecked(){
			const self = this;
			this.checked_item = [];

            if (!this.checked_all) {
				_.forEach(self.survey_item_list, (item, idx) => {
					idx;
					self.checked_item.push(item.surveyItemId);
				})
            }
		},
		openNewSurveyModal: function() {
			this.modals.ModalSurveyRegister.show = true;
		},
		openNewSurveyExcelModal: function() {
			this.modals.ModalSurveyRegisterExcel.show = true;
		},
		removeAllItem(){
			this.modals.ModalConfirm.msg = "설문문항을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnNo.name = "삭제";
			this.modals.ModalConfirm.show = true;
		},
		deleteSurvey: function(surveyItemId) {
			this.remove_survey_item = surveyItemId;
			this.modals.ModalConfirm.msg = "설문문항을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnNo.name = "삭제";
			this.modals.ModalConfirm.show = true;
		},
		removeItem(){
			this.modals.ModalConfirm.show = false;
			if(this.remove_survey_item == ''){
				let removeItems = [];
				_.forEach(this.checked_item, (id) => {
					removeItems.push({surveyItemId : id});
				});
				server.deleteListAxios('SURVEY_ITEM', removeItems, () => {
					// this.getList(this.init_list[2].db_name, this.init_list[2].list_name, {parentsId : 0});
					this.modals.ModalSurveyDetail.show = false;
					this.refreshData({msg: "삭제 되었습니다."})();
				});
			}else{
				server.deleteAxios('SURVEY_ITEM', {id :this.remove_survey_item}, () => {
					this.remove_survey_item == '';
					// this.getList(this.init_list[2].db_name, this.init_list[2].list_name, {parentsId : 0});
					this.modals.ModalSurveyDetail.show = false;
					this.refreshData({msg: "삭제 되었습니다."})();
				});
			}

		},
		removeCancleItem(){
			this.modals.ModalConfirm.show = false;
			this.remove_survey_item = '';
		},
		getList (db_name, list_name, config_option){
			// select_name : 선택 분류, parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
			let config = config_option || {};
			server.postAxios(db_name, config, ({data , err}) => {
				err;
				if(list_name == 'survey_item_list'){
					this.totalCount = parseInt(data.filtered)
				}
				this[list_name] = data.list
			});
		},
		getSurveyDetail(surveyItem){
			const self = this;
			server.postAxios('SURVEY_ITEM', {parentsId : surveyItem.surveyItemId}, ({data , err}) => {
				err;
				self.modals.ModalSurveyDetail.choiceList = data.list;
				self.modals.ModalSurveyDetail.surveyItem = surveyItem;
				self.modals.ModalSurveyDetail.survey_category_list = self.survey_category_list
				self.modals.ModalSurveyDetail.show=true;
			});

		},
		modifySurveyItem(surveyItem){
			this.modals.ModalSurveyModify.surveyItem = surveyItem;
			this.modals.ModalSurveyModify.refreshData = this.refreshData({msg: "수정 되었습니다."});
			this.modals.ModalSurveyModify.show=true;
		}

	}
}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}

.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>